import '../scss/pages.scss';
import '../scss/legal.scss';
import '../components/contact-actions';
import { carouselProductsToggle } from '../components/carousel';
import { toggleDataActive } from '../utils/toggle-dataset';
import { validateFormContact } from "../components/form-contact";
import { initializeCustomSelect } from '../components/custom-select';
import { removeSelected } from '../components/wishlist/removeSelected.js';

validateFormContact();

carouselProductsToggle(
  '.tabs-grid__container',
  '.tabs-grid__navigation #js-tabs-grid-btn-1',
  '.tabs-grid__navigation #js-tabs-grid-btn-2'
)

toggleDataActive(
  '#calendly-button-js',
  '#calendly-modal-js',
  { overlay: true, closeSelector: '#calendly-close-btn-js', blockScroll: true }
);

toggleDataActive(
  '#open-contactform-js',
  '#contactform-js',
  {
    overlay: true,
    closeSelector: '#close-contactform-js',
  }
);

if (!window.location.pathname.includes('faq')) {
  initializeCustomSelect();
}

// Wishlist
removeSelected()

